module.exports = __webpack_public_path__ + "img/hk_room_floorplan_07_en.71227eb3.png";